/**
 * Loads jQuery/Slick and analytics after idle to reduce forced reflow during LCP.
 */
(function () {
  const JQUERY_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js';
  const SLICK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function flushJQueryQueue() {
    const queue = window.pullpyVendor && window.pullpyVendor.jq;
    if (!queue) return;
    while (queue.length) {
      const callback = queue.shift();
      try {
        callback(window.jQuery);
      } catch (error) {
        console.error(error);
      }
    }
  }

  function loadJQueryAndSlick() {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      flushJQueryQueue();
      return Promise.resolve();
    }

    return loadScript(JQUERY_URL)
      .then(function () {
        return loadScript(SLICK_URL);
      })
      .then(flushJQueryQueue);
  }

  function loadClarity() {
    if (window.clarity || document.querySelector('script[src*="clarity.ms"]')) return;
    const clarityId = window.pullpyVendor && window.pullpyVendor.clarityId;
    if (!clarityId) return;

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', clarityId);
  }

  function loadKlaviyo() {
    const config = window.pullpyVendor && window.pullpyVendor.klaviyo;
    if (!config || window.__pullpyKlaviyoLoaded) return;
    window.__pullpyKlaviyoLoaded = true;

    loadScript('https://a.klaviyo.com/media/js/onsite/onsite.js')
      .then(function () {
        const klaviyo = window.klaviyo || [];
        window.klaviyo = klaviyo;
        klaviyo.init({
          account: config.account,
          platform: 'shopify',
        });
        if (config.backInStock) {
          klaviyo.enable('backinstock', config.backInStock);
        }
      })
      .catch(function () {
        window.__pullpyKlaviyoLoaded = false;
      });
  }

  function schedule(task, delay) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(task, { timeout: delay });
      return;
    }
    window.addEventListener('load', function () {
      setTimeout(task, 0);
    });
  }

  function scheduleVendors() {
    const start = function () {
      requestAnimationFrame(function () {
        loadJQueryAndSlick().catch(function (error) {
          console.error(error);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  scheduleVendors();
  schedule(loadClarity, 4000);
  schedule(loadKlaviyo, 5000);
})();
